import { isBefore, parseISO, subMinutes } from "date-fns";

export const isMoreThanXMinutesAgo = (dateString: string, minutes: number) => {
  const date = parseISO(dateString); // parses ISO string to Date
  const fiveMinutesAgo = subMinutes(new Date(), minutes);
  return isBefore(date, fiveMinutesAgo);
};

/** e.g. `Los Angeles (GMT-7)` from the browser IANA zone and current offset. */
export function formatLocalTimezoneLabel(date = new Date()): string {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const citySegment = timeZone.includes("/") ? (timeZone.split("/").pop() ?? timeZone) : timeZone;
  const city = citySegment.replace(/_/g, " ");

  let offset: string | undefined;
  try {
    offset = new Intl.DateTimeFormat("en-US", {
      timeZone,
      timeZoneName: "shortOffset",
    })
      .formatToParts(date)
      .find((p) => p.type === "timeZoneName")?.value;
  } catch {
    offset = undefined;
  }

  if (!offset) {
    offset =
      new Intl.DateTimeFormat("en-US", {
        timeZone,
        timeZoneName: "short",
      })
        .formatToParts(date)
        .find((p) => p.type === "timeZoneName")?.value ?? "";
  }

  return offset ? `${city} (${offset})` : city;
}
